<template>
  <div class="bottom-nav">
    <ul class="bottom-nav-list">
        <li v-for="item in menuItem" :key="item.index" @click="$router.push(item.routeTo)">
            {{item.title}} <span>丨</span>
        </li>
    </ul>
    <div class="bottom-text">
      <div>
          <span> Copyright © 2017-{{new Date().getFullYear()}}</span>
          <span><a target="_blank" class="mr-0" href="https://beian.miit.gov.cn">ICP备案：浙ICP备2020041054号-{{_IsDevMode?2:7}}</a></span>
          <span v-if="!_IsDevMode">
            <a target="_blank" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=33010202005224" class="d-flex align-items-center" >
              <img src="/images/public/beian.png" alt="" height="15">浙公网安备 33010202005224号
            </a>
          </span>
          <span v-else>
            本网站为订单雨内部测试使用，不对外开放。主体信息与dingdanyu.com一致。
          </span>
      </div>
      <div class="customer-service">
        <p class="phone">0571-89986918</p>
        <p>客服热线:09:00-18:00</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BottomNav',
  components: {},
  props: {},
  data() {
    return {
        menuItem:[                                                           //菜单栏条目
          {index:'0',title:'关于我们',routeTo:'/about_us',icon:'el-icon-info'},
          {index:'1',title:'团队介绍',routeTo:'/about_us/team_detail',icon:'el-icon-document'},
          {index:'2',title:'诚征英才',routeTo:'/about_us/join_us',icon:'el-icon-view'},
          {index:'3',title:'联系我们',routeTo:'/about_us/contact_us',icon:'el-icon-phone'},
        ],
    };
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {},
  methods: {}
};
</script>

<style lang="scss" scoped>
  .bottom-nav{
    width: 1200px;
    text-align: left;
    overflow: hidden;
    margin: 0 auto;
    margin-top: 20px;
  }
  .bottom-nav-list{
    display: flex;
    width: 100%;
    border-bottom: 1px solid #eee;
    padding-bottom: 16px; 
    li{
      font-size: 14px;
      color: #666;
      cursor: pointer;
      span{
        color: #999;
        margin: 0 10px;
      }
      &:hover{
        color: var( --smtc-color-primary);
      }
      &:last-child span{
        display: none;
      }
    }
  }
  .bottom-text{
    margin-top: 10px;
    color: #999;
    display: flex;
    justify-content: space-between;
    span{
      display: block;
      margin-top: 4px;
    }
    a{
      color: #999;
    }
  }
   .customer-service{
    display: flex;
    justify-content:end;
    flex-direction: column;
   }
  .customer-service .phone{
    color: var( --smtc-color-primary);
    font-size: 18px;
    font-weight: bold;

  }
</style>
